import { API_BASE_URL } from '../config/env';
import { isAuthSessionError, notifySessionExpired } from '../utils/authSession';
import { clearGetCache } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, String(value));
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
}

async function getErrorMessage(response) {
  let errorMessage = `API error: ${response.status}`;
  try {
    const data = await response.json();
    if (Array.isArray(data?.errors) && data.errors.length) {
      errorMessage = data.errors.join(', ');
    } else if (data?.message) {
      errorMessage = data.message;
    }
  } catch {
    // ignore parse errors
  }
  return errorMessage;
}

async function handleFailedResponse(response) {
  const errorMessage = await getErrorMessage(response);

  if (isAuthSessionError(response.status, errorMessage)) {
    notifySessionExpired();
    return { success: false, message: errorMessage, data: null };
  }

  throw new Error(errorMessage);
}

export async function getProfile(params) {
  const response = await fetch(`${API_BASE_URL}/api/profile${buildQueryString(params)}`, {
    method: 'GET',
    headers: {
      accept: 'application/json',
      ...getAuthHeaders(),
    },
  });

  if (!response.ok) return handleFailedResponse(response);
  return response.json();
}

export async function updateProfile(formData, params) {
  const response = await fetch(`${API_BASE_URL}/api/profile${buildQueryString(params)}`, {
    method: 'PUT',
    headers: {
      accept: 'application/json',
      ...getAuthHeaders(),
    },
    body: formData,
  });

  if (!response.ok) return handleFailedResponse(response);
  return response.json();
}

export async function deleteProfile(reason = 'No longer using the app') {
  const response = await fetch(`${API_BASE_URL}/api/profile`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ reason }),
  });

  if (!response.ok) return handleFailedResponse(response);

  clearGetCache('GET:/api/profile');

  return response.json();
}
